import React, { useEffect, useState } from 'react';
import ECardFolder from '../ECardFolder/ECardFolder';
import ECardControls from '../ECardControls/ECardControls';
import { ECardView } from '../../Enums/ECardView.enum';
import ECardAllFilesWrapper from '../ECardAllFiles/ECardAllFilesWrapper';
import { ECardType } from '../../Enums/ECardType.enum';
import { DocumentationFolderData } from '../ECardWrapper/ECardWrapper';

// @ts-ignore
import styles from './ECard.module.scss';
import ECardFilesAccessCheck from '../ECardFilesAccessCheck/ECardFilesAccessCheck';
import { DocumentationFile } from '../../../../graphql/graphql';

export interface FileToShare {
	id: string;
	name: string;
	file: DocumentationFile;
}

interface Props {
	folders: DocumentationFolderData[];
	patientId: string;
	targetPatientId?: string;
	reloadFolders: () => void;
	updateFolder: (folderId: string) => void;
	type: ECardType;
}

const ECard: React.FC<Props> = ({
	folders,
	patientId,
	targetPatientId,
	reloadFolders,
	updateFolder,
	type,
}) => {
	const [view, setView] = useState<ECardView>(ECardView.LIST);
	const [filter, setFilter] = useState<string | undefined>();
	const [isShareMode, setIsShareMode] = useState(true);
	const [isAllFilesToggled, setIsAllFilesToggled] = useState(false);
	const [filesToShare, setFilesToShare] = useState<FileToShare[]>([]);

	useEffect(() => {
		if (!isShareMode) {
			setFilesToShare([]);
		}
	}, [isShareMode]);

	const handleAddItemToItemsToShare = (
		file: FileToShare,
		isChecked: boolean,
	) => {
		setFilesToShare(prev => {
			if (isChecked) {
				return [...prev, file];
			}
			return prev.filter(item => item.id !== file.id);
		});
	};

	const reloadEventHandler: (() => void)[] = [];

	return (
		<div className={styles.wrapper}>
			<ECardControls
				view={view}
				setView={setView}
				setFilter={setFilter}
				filter={filter}
				patientId={patientId}
				targetPatientId={targetPatientId}
				reloadFolders={reloadFolders}
				updateFolder={updateFolder}
				setIsShareMode={setIsShareMode}
				isShareMode={isShareMode}
				filesToShare={filesToShare}
				type={type}
				reloadEvent={reloadEventHandler}
			/>
			<div className={styles.content}>
				{type === ECardType.PATIENT_E_CARD && (
					<ECardFilesAccessCheck patientId={patientId} />
				)}
				<ECardAllFilesWrapper
					setIsAllFilesToggled={setIsAllFilesToggled}
					isAllFilesToggled={isAllFilesToggled}
					patientId={patientId}
					view={view}
					filter={filter}
					isShareMode={isShareMode}
					onItemCheck={handleAddItemToItemsToShare}
					filesToShare={filesToShare}
					reloadEvent={reloadEventHandler}
					eCardType={type}
				/>
				{!isAllFilesToggled &&
					folders?.map(item => (
						<React.Fragment key={item.id}>
							<ECardFolder
								item={item}
								view={view}
								patientId={patientId}
								filter={filter}
								isShareMode={isShareMode}
								onItemCheck={handleAddItemToItemsToShare}
								filesToShare={filesToShare}
								updateFolder={updateFolder}
								eCardType={type}
							/>
						</React.Fragment>
					))}
			</div>
		</div>
	);
};

export default ECard;
